<template>
  <div v-if="breadcrumbStore.breadcrumbs.length > 0" class="breadcrumbs text-sm">
    <ul>
      <li v-for="breadcrumb in breadcrumbStore.breadcrumbs" :key="`breadcrumb-${breadcrumb.name}`">
        <router-link v-if="breadcrumb.to" :to="breadcrumb.to">{{ breadcrumb.name }}</router-link>
        <span v-else>{{ breadcrumb.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { useBreadcrumbStore } from '../../stores/breadcrumb.ts';

export default {
  setup() {
    const breadcrumbStore = useBreadcrumbStore();
    return { breadcrumbStore };
  },
};
</script>
